module.exports = __webpack_public_path__ + "static/5-d316449cf013e0420fdf17a1fab61efc.jpg";